module.exports = __webpack_public_path__ + "img/yangjilong.11606ee4.jpg";